import { render, staticRenderFns } from "./ModalFirmantes.vue?vue&type=template&id=5f353abe&scoped=true&"
import script from "./ModalFirmantes.vue?vue&type=script&lang=js&"
export * from "./ModalFirmantes.vue?vue&type=script&lang=js&"
import style0 from "./ModalFirmantes.vue?vue&type=style&index=0&id=5f353abe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f353abe",
  null
  
)

export default component.exports